import { render, staticRenderFns } from "./RunTimeStatistics.vue?vue&type=template&id=70a7993a&scoped=true"
import script from "./RunTimeStatistics.vue?vue&type=script&lang=js"
export * from "./RunTimeStatistics.vue?vue&type=script&lang=js"
import style0 from "./RunTimeStatistics.vue?vue&type=style&index=0&id=70a7993a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7993a",
  null
  
)

export default component.exports